import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { TTemplateComponent } from "../@types/component/TTemplateComponent";
import { TGlobalState } from "../@types/State/TGlobalState";
import { TDispatch } from "../@types/TDispatch";
import {
  getWhiteLabelGroupsSelector,
  menuLinksWhiteLabelGroupSelector,
} from "../store/selectors";

import Footer from "./Footer";
import Header from "./Header";

import { Container, Content } from "./styles";

const Template: React.FC<TTemplateComponent> = ({
  getWhiteLabelGroupsState,
  menuLinksWhiteLabelGroupState,
  children,
}) => {
  if (!getWhiteLabelGroupsState?.data) return null;

  return (
    <Container>
      <Header
        partnerName={getWhiteLabelGroupsState.data?.partnerName}
        logo={getWhiteLabelGroupsState.data?.template.headerLogo}
        menuLinks={menuLinksWhiteLabelGroupState}
        socialNetworks={getWhiteLabelGroupsState.data?.socialNetworks}
      />

      <Content>{children}</Content>
      <Footer
        partnerName={getWhiteLabelGroupsState.data?.partnerName}
        logo={getWhiteLabelGroupsState.data?.template.footerLogo}
        socialNetworks={getWhiteLabelGroupsState.data?.socialNetworks}
      />
    </Container>
  );
};

const mapStateToProps = (state: TGlobalState) => {
  return {
    getWhiteLabelGroupsState: getWhiteLabelGroupsSelector(state),
    menuLinksWhiteLabelGroupState: menuLinksWhiteLabelGroupSelector(state),
  };
};

const mapDispatchtoProps = (dispatch: TDispatch) =>
  bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchtoProps)(Template);
